import wootConstants from 'dashboard/constants/globals';

// Aba em que a lista de conversas abre, configurável por conta
// (Super Admin → settings.default_conversation_tab). Sem configuração: "Todos".
const ABAS_INICIAIS = ['unread', 'me', 'unassigned', 'all'];

export const abaInicialDasConversas = accountSettings => {
  const aba = accountSettings?.default_conversation_tab;
  return ABAS_INICIAIS.includes(aba) ? aba : wootConstants.ASSIGNEE_TYPE.ALL;
};
